import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

export const RedStartIcon = ({ className }: { className?: string }) => (
  <SVGUniqueID>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M10.624 1.094a.667.667 0 0 0-1.245 0l-.786 2.043c-.2.52-.263.67-.349.792a1.3 1.3 0 0 1-.314.314c-.121.086-.271.149-.792.35l-2.043.785a.667.667 0 0 0 0 1.244l2.043.786c.521.2.671.263.792.35q.184.13.314.313c.086.121.15.271.35.792l.785 2.043a.667.667 0 0 0 1.245 0l.785-2.043c.2-.52.263-.67.35-.792q.13-.183.313-.314c.122-.086.272-.149.792-.349l2.043-.786a.667.667 0 0 0 0-1.244l-2.043-.786c-.52-.2-.67-.263-.792-.35a1.3 1.3 0 0 1-.313-.313c-.087-.121-.15-.271-.35-.792zM4.93 8.369a.667.667 0 0 0-1.192 0l-.523 1.046c-.188.376-.245.485-.315.575q-.105.136-.242.242c-.09.07-.199.127-.576.316l-1.046.522a.667.667 0 0 0 0 1.193l1.046.523c.377.188.485.246.576.315q.136.106.242.242c.07.09.127.2.315.576l.523 1.046a.667.667 0 0 0 1.193 0l.523-1.046c.188-.377.246-.485.315-.575q.106-.137.242-.243c.09-.07.2-.127.576-.315l1.046-.523a.667.667 0 0 0 0-1.193l-1.046-.523c-.377-.188-.485-.245-.576-.315a1.3 1.3 0 0 1-.242-.242c-.07-.09-.127-.199-.315-.575z"
        fill="#991b1b"
      />
    </svg>
  </SVGUniqueID>
);
